export default __webpack_public_path__ + "static/media/P20-Plunger.c3b38a72.svg";